import { ResourcesPanel } from "@/components/ResourcesPanel";
export default function CoachResources() { return <ResourcesPanel testid="coach-resources" />; }
